import { render, staticRenderFns } from "./DiscountInformation.vue?vue&type=template&id=b0c0885c&scoped=true&"
import script from "./DiscountInformation.vue?vue&type=script&lang=js&"
export * from "./DiscountInformation.vue?vue&type=script&lang=js&"
import style0 from "./DiscountInformation.vue?vue&type=style&index=0&id=b0c0885c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c0885c",
  null
  
)

export default component.exports